<template>
  <div>
     <brandIntro :info="info"></brandIntro>
     <locationList :location="info.location"></locationList>
  </div>
</template>
<script>
import { brandIntro, locationList } from './components'
export default {
  components: {
    brandIntro,
    locationList
  },
  data () {
    return {
      info: {}
    }
  },
  methods: {
    getCakeBrandInfo () {
      this.info = {
        bg: require('@/assets/cake/banner/brand-bg.png'),
        logo: require('@/assets/cake/brand/starbucks.png'),
        name: '星巴克',
        spec: `
          简介：星巴克是一家全球知名的咖啡连锁品牌，成立于1971年，总部位于美国西雅图。其以咖啡饮品为主打产品，提供多样化的咖啡、茶、甜点等，打造了独特的社交场所，成为全球咖啡成为全球咖啡成为全球咖啡成为全球咖啡成为全球咖啡成为全球咖啡成为全球咖啡成为全球咖啡成为全球咖啡成为全球咖啡
        `,
        location: [
          {
            shop_id: 1,
            shop_name: '星巴克(广州海珠万达店)',
            address: '逸景路238号海珠万达广场首层A1021B',
            shop_distance: '700cm'
          },
          {
            shop_id: 2,
            shop_name: '星巴克(广州海珠万达店)',
            address: '逸景路238号海珠万达广场首层A1021B',
            shop_distance: '750cm'
          },
          {
            shop_id: 3,
            shop_name: '星巴克(广州海珠万达店)',
            address: '逸景路238号海珠万达广场首层A1021B',
            shop_distance: '820cm'
          },
          {
            shop_id: 4,
            shop_name: '星巴克(广州海珠万达店)',
            address: '逸景路238号海珠万达广场首层A1021B',
            shop_distance: '1200cm'
          }
        ]
      }
    }
  },
  created() {
    this.getCakeBrandInfo()
  },
}
</script>